import {CURRENT_USER} from '../../components/constants/common.constants.js';
import {api} from '../../globalConfig.js';
import {extract_token} from './common.js';
import axios from 'axios';

export const getSessionData = key => {
    return JSON.parse(sessionStorage.getItem(key));
}

export const setSessionData = (key, data) => {
    sessionStorage.setItem(key, JSON.stringify(data))
}

export const fetchSessionUser = async () => {
    let response = getSessionData(CURRENT_USER)
    if (response) return response;

    const pathName = api.COMMON_URL + extract_token;
    axios
        .get(pathName)
        .then((res) => {
            setSessionData(CURRENT_USER, res)
        })
        .catch((err) => {
            console.log(err);
            return null
        });
}

